import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-md-4 left" }
const _hoisted_2 = { class: "col-md-8 right" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "news-links" }
const _hoisted_6 = { class: "internal" }
const _hoisted_7 = ["href", "target", "data-analytics-element-target", "data-analytics-element-title"]

import { computed } from 'vue';
    import { NewsItem } from '@/types';
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'LzNewsItem',
  props: {
    id: {},
    abstractText: {},
    link: {},
    title: {},
    date: {},
    categories: {},
    relatedLinks: {}
  },
  setup(__props: any) {

const props = __props;

    
    
    const formatDate = (timestamp: number): string => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };
    
    const formattedDate = computed(() => formatDate(props.date));
    const formattedClass = computed(() => {
        const year = new Date(props.date).getFullYear();
        const categoriesList = props.categories.map(category => category.title.toLowerCase()).join(' ');
        return `news ${categoriesList} ${year}`;
    });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(formattedClass.value)
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(formattedDate.value), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "news-title",
        href: _ctx.link
      }, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
      ], 8, _hoisted_3),
      _createElementVNode("p", { innerHTML: _ctx.abstractText }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedLinks, (relatedLink, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("a", {
                  href: relatedLink.href,
                  target: relatedLink.target,
                  "data-analytics-event-name": "link_click",
                  "data-analytics-event-category": "Link",
                  "data-analytics-element-target": relatedLink.href,
                  "data-analytics-element-title": relatedLink.title,
                  "data-analytics-element-type": "News"
                }, _toDisplayString(relatedLink.title), 9, _hoisted_7)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 2))
}
}

})